<template>
  <div class="contenedor-difusion">
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Crear Mentoreado</h1>
        <div class="barra"></div>
      </div>
      <router-link :to="`/mentorias`" class="boton_volver_login"><span>&#8592;</span> Atrás</router-link>
      <section class="contenedor-login">
        <div class="contenedor-crear-mentoreado-imagen">
          <img src="@/assets/Virasana.png" alt="Postura Virasana">
        </div>
        <div class="contenedor-crear-mentoreado-text">
          <p>Estimados profesores,</p>

          <p>Aquí encuentran el Formulario para inscribir a las personas que inician la Mentoría bajo su guía.</p>

          <p>La mentoría queda registrada desde que este formulario se completa y llega un email formal de CMC con la confirmacion correspondiente, antes de hacerlo el CMC chequeara con Tesoreria que el mentoreado sea socio y con la cuota al dia de la AAYI ( requsito excluyente ).</p>

          <p>IMPORTANTE: </p>
          <ul class="lista_precios_seminario">
            <li><span>&#8226;</span> Para presentar a alguien a la Certificación, se requieren 2 (dos) años en el Registro Nacional de Mentorías.</li>
            <li><span>&#8226;</span> El límite de mentoreados es de 8 candidatos por mentor.</li>
            <li><span>&#8226;</span> La fecha de inicio formal de la mentoria es la fecha en que se envia este formulario, sin excepción.</li>
            <li><span>&#8226;</span> El Comité de mentorías y certificación enviará un email de confirmación al mentor y mentoreado, luego de que llegue la inscripción.</li>
          </ul>
          <form
            action="#"
            method="post"
            @submit.prevent="crearMentor(mentor)"
            class="form_crear_mentoreado"
            v-if="mostrarForm"
          >
            <div class="form_section">
              <label for="alumno_id" class="label_crear_mentor">Nombre del mentoreado</label>
              <v-select
                class="contenedor_select_buscador"
                v-model="mentor.alumno_id"
                label="item_data"
                :reduce="socios => socios.persona_id"
                :options="socios"
                :disabled="cargando"
                @input="validar"
              >
                <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
                  <p>La persona ingresada no figura en nuestros registros.</p>
                </span>
              </v-select>
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.alumno_id !== null"
              >
                {{ errores.alumno_id[0] }}
              </div>
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="mostrarMensajeCuotaVencida"
              >
                El alumno no puede ser inscripto por no tener la cuota al día
              </div>
            </div>
            <div class="form_section">
              <label for="tiempo_toma_clase" class="label_crear_mentor">¿Hace cuanto toma clase de Yoga Iyengar?</label>
              <input
                type="text"
                name="tiempo_toma_clase"
                id="tiempo_toma_clase"
                v-model="mentor.tiempo_toma_clase"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.tiempo_toma_clase !== null"
              >
                {{ errores.tiempo_toma_clase[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="tiempo_toma_clase_mentor" class="label_crear_mentor">¿Hace cuanto toma clases con su mentor?</label>
              <input
                type="text"
                name="tiempo_toma_clase_mentor"
                id="tiempo_toma_clase_mentor"
                v-model="mentor.tiempo_toma_clase_mentor"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.tiempo_toma_clase_mentor !== null"
              >
                {{ errores.tiempo_toma_clase_mentor[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="cuantas_clases_semanales" class="label_crear_mentor">¿Cuantas clases semanales toma?</label>
              <input
                type="text"
                name="cuantas_clases_semanales"
                id="cuantas_clases_semanales"
                v-model="mentor.cuantas_clases_semanales"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.cuantas_clases_semanales !== null"
              >
                {{ errores.cuantas_clases_semanales[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="formato_clase_mentor" class="label_crear_mentor">¿Toma clases en formato online o presencial con el mentor?</label>
              <input
                type="text"
                name="formato_clase_mentor"
                id="formato_clase_mentor"
                v-model="mentor.formato_clase_mentor"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.formato_clase_mentor !== null"
              >
                {{ errores.formato_clase_mentor[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="clases_presenciales_ciudad" class="label_crear_mentor">En caso de tomar clases regulares online con el mentor, ¿Toma clases presenciales con algún profesor certificado en su ciudad?</label>
              <input
                type="text"
                name="clases_presenciales_ciudad"
                id="clases_presenciales_ciudad"
                v-model="mentor.clases_presenciales_ciudad"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.clases_presenciales_ciudad !== null"
              >
                {{ errores.clases_presenciales_ciudad[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="porque_no" class="label_crear_mentor">Si la respuesta fue no, especificar por qué (aclarar si no hay profesores certificados en el lugar de residencia del mentoreado)</label>
              <input
                type="text"
                name="porque_no"
                id="porque_no"
                v-model="mentor.porque_no"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.porque_no !== null"
              >
                {{ errores.porque_no[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="cuantas_clases_dicta" class="label_crear_mentor">¿Cuantas clases semanles enseña?</label>
              <input
                type="text"
                name="cuantas_clases_dicta"
                id="cuantas_clases_dicta"
                v-model="mentor.cuantas_clases_dicta"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.cuantas_clases_dicta !== null"
              >
                {{ errores.cuantas_clases_dicta[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="formacion_anterior" class="label_crear_mentor">¿Tiene una formación anterior? Especificar</label>
              <input
                type="text"
                name="formacion_anterior"
                id="formacion_anterior"
                v-model="mentor.formacion_anterior"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.formacion_anterior !== null"
              >
                {{ errores.formacion_anterior[0] }}
              </div>
            </div>
            <div class="form_section">
              <label for="observaciones" class="label_crear_mentor">Observaciones y consideraciones sobre el mentoreado</label>
              <textarea
                name="observaciones"
                id="observaciones"
                v-model="mentor.observaciones"
              ></textarea>
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.observaciones !== null"
              >
                {{ errores.observaciones[0] }}
              </div>
            </div>
            <button type="submit" v-if="mostrarBoton">Crear Mentoreado</button>
          </form>
          <div
            class="form_mensaje_error_crear_mentor"
              v-if="mostrarMensajeCupoLleno"
            >
              Ya has alcanzado el límite de mentoreados que puedes inscribir
            </div>
        </div>
      </section>
    </section>
  </div>
</template>
<script src="https://unpkg.com/vue@2"></script>
<script src="https://unpkg.com/vue-select@latest"></script>
<script>
import 'vue-select/dist/vue-select.css';
import pagosService from '../services/pagos'
import mentorService from '../services/mentor'
import asociadoService from '../services/asociado'
import store from './../store'

export default {
  name: 'CrearMentoreado',
  components: {
  },
  data: function () {
    return {
      options: [
        'foo',
        'bar',
        'baz'
      ],
      count: 1,
      conceptos: [],
      cuotasSelect: [],
      socios: [],
      servicios: [],
      formasDePago: [],
      monedas: [],
      years: [],
      personas: [],
      cargando: false,
      mentor: {
        certificacion_id: null,
        alumno_id: null,
        mentor_id: JSON.parse(localStorage.getItem('userData')).persona_id,
        condiciones_mentoria_id: 1, // Mentoria pendiente
        // fecha_inicio: null,
        tiempo_toma_clase: null,
        tiempo_toma_clase_mentor: null,
        cuantas_clases_semanales: null,
        formato_clase_mentor: null,
        clases_presenciales_ciudad: null,
        porque_no: null,
        cuantas_clases_dicta: null,
        formacion_anterior: null,
        observaciones: null
      },
      errores: {
        alumno_id: null,
        mentor_id: null,
        // fecha_inicio: null,
        tiempo_toma_clase: null,
        tiempo_toma_clase_mentor: null,
        cuantas_clases_semanales: null,
        formato_clase_mentor: null,
        clases_presenciales_ciudad: null,
        porque_no: null,
        cuantas_clases_dicta: null,
        formacion_anterior: null,
        observaciones: null
      },
      mostrarBoton: true,
      mostrarMensajeCuotaVencida: false,
      mostrarForm: false,
      mostrarMensajeCupoLleno: false,
      store
    }
  },
  methods: {
    // addComponent () {
    //   this.count += 1
    //   console.log(this.servicio.productos.push({
    //     servicio_id: null,
    //     precio: null,
    //     cantidad: null
    //   }))
    // },
    // onChange (event) {
      // console.log(numero)
      // console.log(event.target.value)
      // console.log(event.target.name)
      // console.log(document.getElementsByClassName('year'))
      // if (event.target.value === '1' || event.target.value === '2' || event.target.value === '3' || event.target.value === '4') {
      //   console.log(event.target.value)
      //   document.getElementById('cuota').style.display = 'flex'
      // } else {
      //   document.getElementById('cuota').style.display = 'none'
      // }
      // if (event.target.value != null) {
      //   console.log(event.target.value)

      //   document.getElementById('cuota').style.display = 'flex'
      //   serviciosService
      //     .listarServicioConCuotasPorId(event.target.value)
      //     .then(respuesta => {
      //       // this.cargando = false
      //       this.cuotasSelect = respuesta
      //       console.log('ServicioConInfo: ', respuesta)
      //     })

      // }
      // console.log(this.productos[event.target.value - 1].precio)
      // // document.getElementsByName('precio-' + numero)[0].value = this.productos[event.target.value - 1].precio
      // this.servicio.productos[numero - 1].precio = this.productos[event.target.value - 1].precio
    // },
    validar () {
      console.log(this.mentor.alumno_id)
      if (this.mentor.alumno_id != null) {
        console.log(this.mentor.alumno_id)
        pagosService
          .validarSocioAlDia(this.mentor.alumno_id)
          .then(respuesta => {
            this.cargando = false
            console.log('Validar Socio:', respuesta)
            if (respuesta.success) {
              console.log('pago')
            } else {
              console.log('NO pago')
              this.mostrarBoton = false
              this.mostrarMensajeCuotaVencida = true
              // this.texto = respuesta.mensaje
              // this.clase = 'fondo-rojo'
              // this.mostrarMensajeIncripcionSeminario = true
            }
          })
      } else {
        this.mostrarBoton = true
        this.mostrarMensajeCuotaVencida = false
      }
    },
    crearMentor (mentor) {
      console.log('qqqq')
      console.log(mentor)
      if (this.cargando) {
        return null
      }
      this.cargando = true
      mentorService
        .crearMentor(mentor)
        .then(respuesta => {
          this.cargando = false
          if (respuesta.success) {
            console.log('SIIIIII')
            this.mentor = {
              certificacion_id: null,
              alumno_id: null,
              mentor_id: JSON.parse(localStorage.getItem('userData')).persona_id,
              // fecha_inicio: null,
              tiempo_toma_clase: null,
              tiempo_toma_clase_mentor: null,
              cuantas_clases_semanales: null,
              formato_clase_mentor: null,
              clases_presenciales_ciudad: null,
              porque_no: null,
              cuantas_clases_dicta: null,
              formacion_anterior: null,
              observaciones: null
            }
            this.errores = {
              alumno_id: null,
              mentor_id: null,
              // fecha_inicio: null,
              tiempo_toma_clase: null,
              tiempo_toma_clase_mentor: null,
              cuantas_clases_semanales: null,
              formato_clase_mentor: null,
              clases_presenciales_ciudad: null,
              porque_no: null,
              cuantas_clases_dicta: null,
              formacion_anterior: null,
              observaciones: null
            }
            // this.store.setStatus({
            //   msg: 'El pago se creo exitosamente',
            //   type: 'success'
            // })
            this.$router.push('/mentorias')
          } else {
            this.errores = {
              alumno_id: null,
              mentor_id: null,
              // fecha_inicio: null,
              tiempo_toma_clase: null,
              tiempo_toma_clase_mentor: null,
              cuantas_clases_semanales: null,
              formato_clase_mentor: null,
              clases_presenciales_ciudad: null,
              porque_no: null,
              cuantas_clases_dicta: null,
              formacion_anterior: null,
              observaciones: null,
              ...respuesta.errors
            }
          }
        })
    }
  },
  mounted: function () {
    mentorService
      .checkCupoMentoresPorMentorId(JSON.parse(localStorage.getItem('userData')).persona_id)
      .then(respuesta => {
        if (respuesta.success) {
          this.mostrarForm = true
          this.mostrarMensajeCupoLleno = false
        } else {
          this.mostrarForm = false
          this.mostrarMensajeCupoLleno = true
        }
        console.log(respuesta)
      })
    asociadoService
      .listadoSociosMentoriaNivel1()
      .then(respuesta => {
        // this.cargando = false
        this.socios = respuesta
        console.log('listadoSociosSelect:', respuesta)
        this.socios.map(function (x) {
          // const pepe = x.nombre + ' ' + x.apellido
          // console.log(pepe)
          x.item_data = x.nombre + ' ' + x.apellido
          // return x.item_data = pepe
        })
      })
    // pagosService
    //   .traerConceptosDePago()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.conceptos = respuesta
    //     console.log('Conceptos: ', respuesta)
    //   })
    // pagosService
    //   .traerFormasDePago()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.formasDePago = respuesta
    //     console.log('Formas de Pago: ', respuesta)
    //   })
    // pagosService
    //   .traerMonedas()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.monedas = respuesta
    //     console.log('Monedas: ', respuesta)
    //   })
    // pagosService
    //   .traerYearsDePago()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.years = respuesta
    //     console.log('Years: ', respuesta)
    //   })
    // personasService
    //   .traerCertificacionesTodas()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.certificaciones = respuesta
    //   })
    // pagosService
    //   .traerFormasDePago()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.formasDePago = respuesta
    //   })
    // pagosService
    //   .traerMonedas()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.monedas = respuesta
    //   })
    // pagosService
    //   .traerPersonas()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.personas = respuesta
    //     console.log('Personas: ', respuesta)
    //   })
  }
}
</script>
<style>
#cuota {
  display: none;
}
.select_buscador {
  flex: 1;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: black;
  margin: 10px 0;
}

.vs__selected-options {
/*  padding: 0 12px !important;*/
  position: relative;
}
.vs__search {
  border: none !important;
/*  border: 2px solid red !important;*/
  margin: 0 !important;
  height: 45px !important;
}
.vs--single .vs__selected {
  width: 100% !important;
  font-size: 1em;
}
.vs__selected {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 12px !important;
  color: black !important;
  margin: 12px 0 7px !important;
}
.vs__dropdown-toggle {
  padding: 0 !important;
}

.vs__clear {
/*  display: none;*/
}

.vs__open-indicator {
  display: none;
}

</style>
